(() => {
  const widgetSelector = '.jdgm-rev-widg';
  const reviewSelector = '.jdgm-rev';
  const reviewsPerStep = 3;
  const reviewsPerPage = 10;
  const reviewsEndpoint = 'https://api.judge.me/reviews/reviews_for_widget';
  let observerTimer;

  const addExpandControl = (review) => {
    const body = review.querySelector('.jdgm-rev__body');
    if (!body || body.textContent.trim().length < 260 || review.querySelector('.ls-review-expand')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ls-review-expand';
    button.textContent = 'Read full review';
    button.setAttribute('aria-expanded', 'false');
    body.insertAdjacentElement('afterend', button);
  };

  const ensureLoadControl = (widget) => {
    let actions = widget.querySelector('.ls-review-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'ls-review-actions';
      actions.innerHTML = '<button type="button" class="ls-review-load-more">Load more reviews</button>';
      const reviewsContainer = widget.querySelector('.jdgm-rev-widg__reviews');
      reviewsContainer?.insertAdjacentElement('afterend', actions);
    }
    return actions;
  };

  const prepareWidget = (widget) => {
    const reviews = [...widget.querySelectorAll(reviewSelector)];
    if (!reviews.length) return;

    if (!widget.dataset.lussoVisibleReviews) {
      widget.dataset.lussoVisibleReviews = String(reviewsPerStep);
    }
    if (!widget.dataset.lussoLoadedPage) widget.dataset.lussoLoadedPage = '1';

    const totalReviews = Number(widget.dataset.numberOfReviews || reviews.length);
    const visibleCount = Math.min(
      Number(widget.dataset.lussoVisibleReviews || reviewsPerStep),
      reviews.length,
      totalReviews
    );

    reviews.forEach((review, index) => {
      review.hidden = index >= visibleCount;
      addExpandControl(review);
    });

    const actions = ensureLoadControl(widget);
    const button = actions?.querySelector('.ls-review-load-more');
    if (!button) return;

    actions.hidden = visibleCount >= totalReviews;
    button.disabled = widget.dataset.lussoLoading === 'true';
    const label = button.disabled ? 'Loading reviews' : 'Load more reviews';
    if (button.textContent !== label) button.textContent = label;
  };

  const loadNextPage = async (widget, button) => {
    if (widget.dataset.lussoLoading === 'true') return;

    const shopDomain = window.LussoJudgeMe?.shopDomain;
    const productId = widget.closest('[data-product-id]')?.dataset.productId;
    const nextPage = Number(widget.dataset.lussoLoadedPage || 1) + 1;
    if (!shopDomain || !productId) return;

    widget.dataset.lussoLoading = 'true';
    button.disabled = true;
    button.textContent = 'Loading reviews';

    try {
      const params = new URLSearchParams({
        shop_domain: shopDomain,
        platform: 'shopify',
        product_id: productId,
        page: String(nextPage),
        per_page: String(reviewsPerPage)
      });
      const response = await fetch(`${reviewsEndpoint}?${params}`);
      if (!response.ok) throw new Error(`Judge.me returned ${response.status}`);

      const payload = await response.json();
      const parsed = new DOMParser().parseFromString(payload.html || '', 'text/html');
      const incomingReviews = [...parsed.querySelectorAll(reviewSelector)];
      const reviewsContainer = widget.querySelector('.jdgm-rev-widg__reviews');
      const existingIds = new Set(
        [...widget.querySelectorAll(reviewSelector)].map((review) => review.dataset.reviewId).filter(Boolean)
      );

      incomingReviews.forEach((review) => {
        const reviewId = review.dataset.reviewId;
        if (!reviewId || !existingIds.has(reviewId)) reviewsContainer?.append(review);
      });
      widget.dataset.lussoLoadedPage = String(nextPage);
    } catch (error) {
      console.error('Lusso reviews could not load the next page.', error);
    } finally {
      const loadedReviews = widget.querySelectorAll(reviewSelector).length;
      const currentVisible = Number(widget.dataset.lussoVisibleReviews || reviewsPerStep);
      widget.dataset.lussoVisibleReviews = String(Math.min(currentVisible + reviewsPerStep, loadedReviews));
      widget.dataset.lussoLoading = 'false';
      prepareWidget(widget);
    }
  };

  const prepareAll = () => {
    document.querySelectorAll(widgetSelector).forEach(prepareWidget);
  };

  document.addEventListener('click', (event) => {
    const expandButton = event.target.closest('.ls-review-expand');
    if (expandButton) {
      const review = expandButton.closest(reviewSelector);
      const expanded = review.classList.toggle('is-lusso-expanded');
      expandButton.textContent = expanded ? 'Read less' : 'Read full review';
      expandButton.setAttribute('aria-expanded', String(expanded));
      return;
    }

    const loadButton = event.target.closest('.ls-review-load-more');
    if (!loadButton) return;

    const widget = loadButton.closest(widgetSelector);
    const reviews = [...widget.querySelectorAll(reviewSelector)];
    const visibleCount = Number(widget.dataset.lussoVisibleReviews || reviewsPerStep);

    if (visibleCount < reviews.length) {
      widget.dataset.lussoVisibleReviews = String(Math.min(visibleCount + reviewsPerStep, reviews.length));
      prepareWidget(widget);
      return;
    }

    const totalReviews = Number(widget.dataset.numberOfReviews || reviews.length);
    if (reviews.length < totalReviews) loadNextPage(widget, loadButton);
  });

  const observer = new MutationObserver(() => {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(prepareAll, 60);
  });

  const start = () => {
    prepareAll();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', prepareAll);
})();
